import {parseUtcTimestamp} from './date';

type ProjectOrder = {
  readonly id: string;
  readonly createdAt: string;
};

export const sortProjectsNewestFirst = <T extends ProjectOrder>(projects: readonly T[]): T[] => {
  return [...projects].sort((left: T, right: T) => {
    const leftCreationTime = parseUtcTimestamp(left.createdAt);
    const rightCreationTime = parseUtcTimestamp(right.createdAt);
    const leftTimestampIsValid = Number.isFinite(leftCreationTime);
    const rightTimestampIsValid = Number.isFinite(rightCreationTime);

    if (leftTimestampIsValid && rightTimestampIsValid) {
      const creationTimeDifference = rightCreationTime - leftCreationTime;
      return creationTimeDifference !== 0 ? creationTimeDifference : right.id.localeCompare(left.id);
    }
    if (leftTimestampIsValid) return -1;
    if (rightTimestampIsValid) return 1;
    return right.id.localeCompare(left.id);
  });
};
